// extracted by mini-css-extract-plugin
module.exports = {"container":"_1BR6F4U0MOuzt_wD_M2UrA","title":"_29yXcd7EGj82kdta_Hi-an","btns":"_1qtDFE_iA6jzuYPCYkXhAp","tip":"_1Aogh2W1XVvrk9hg_Y6I1B","link":"_35i4uwyJpTeHfaavEhE70Z"};